import './style.css';

import AOS from 'aos';
import 'aos/dist/aos.css';

import Rellax from 'rellax';

import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

//import 'swiper/css';

// script.ts
const btn = document.getElementById('hamburger-btn') as HTMLButtonElement;
const menu = document.getElementById('menu') as HTMLDivElement;

function showToast(): void {
  if (menu.classList.contains('hidden')) {
    menu.classList.remove('hidden');
  } else {
    menu.classList.add('hidden');
  }
}

btn.addEventListener('click', showToast);

const menuBtns = Array.from(menu.getElementsByTagName('a') as HTMLCollection) as HTMLAnchorElement[];
menuBtns.forEach(menuBtn => {
  menuBtn.addEventListener('click', () => {
    menu.classList.add('hidden');
  });
});

const flipBtns = document.querySelectorAll('[data-flip]');
flipBtns.forEach(flipBtn => {
  flipBtn.addEventListener('click', () => {
    if (flipBtn.classList.contains('flipped') && flipBtn.classList.contains('flipped-force')) {
      flipBtn.classList.remove('flipped', 'flipped-force');
    } else {
      flipBtn.classList.add('flipped', 'flipped-force');
    }
  });

  flipBtn.addEventListener('mouseover', () => {
    if (!flipBtn.classList.contains('flipped')) {
      flipBtn.classList.add('flipped');
    }
  });
  flipBtn.addEventListener('mouseout', () => {
    if (!flipBtn.classList.contains('flipped-force')) {
      flipBtn.classList.remove('flipped');
    }
  });
});

// Definizione del tipo di dato ricevuto dall'API
type CardItem = {
  title: string;
  published_date: string;
};

// Funzione per creare una singola card
function createCard(item: CardItem): HTMLElement {
  const card = document.createElement('div');
  card.className = 'p-4 bg-white text-primary-900 rounded-2xl';
  card.innerHTML = `
    <div class="pill w-fit !text-sm mb-2">Article</div>
    <h4 class="text-lg font-bold mb-4 text-fluid-h4 leading-tight">${item.title}</h4>
    <p class="italic"><strong>Pubblication date:</strong> ${item.published_date}</p>
  `;
  return card;
}

// Funzione per caricare e mostrare i dati
async function loadCards(): Promise<void> {
  const container = document.getElementById('cards');
  if (!container) return;

  try {
    const response = await fetch('https://repertorio.ai/demo/recent-articles');
    if (!response.ok) throw new Error('Errore nella risposta API');

    const data: CardItem[] = await response.json();

    data.forEach(item => {
      const card = createCard(item);
      container.appendChild(card);
    });
  } catch (error) {
    console.error('Errore nel caricamento delle card:', error);
  }
}

// Function to handle form submission
function setupFormSubmission(): void {
  const form = document.querySelector('form') as HTMLFormElement;

  if (!form) return;

  // Add real-time validation
  setupFormValidation(form);

  form.addEventListener('submit', async (e: Event) => {
    e.preventDefault(); // Prevent default form submission

    // Validate form before submission
    if (!validateForm(form)) {
      showMessage('Fill in all required fields.', 'error');
      return;
    }

    const formData = new FormData(form);
    const submitButton = form.querySelector('button[type="submit"]') as HTMLButtonElement;

    // Show loading state
    const originalText = submitButton.textContent;
    submitButton.textContent = 'Sending...';
    submitButton.disabled = true;

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        // Success - show success message and reset form
        showMessage('Message sent successfully!', 'success');
        form.reset();
        clearValidationErrors(form);
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      showMessage('Error sending message. Please try again.', 'error');
    } finally {
      // Reset button state
      submitButton.textContent = originalText;
      submitButton.disabled = false;
    }
  });
}

// Function to setup real-time validation
function setupFormValidation(form: HTMLFormElement): void {
  const inputs = form.querySelectorAll('input[required], textarea[required]');
  const checkbox = form.querySelector('input[type="checkbox"]') as HTMLInputElement;

  inputs.forEach(input => {
    input.addEventListener('blur', () => validateField(input as HTMLInputElement | HTMLTextAreaElement));
    input.addEventListener('input', () => clearFieldError(input as HTMLInputElement | HTMLTextAreaElement));
  });

  if (checkbox) {
    checkbox.addEventListener('change', () => validateCheckbox(checkbox));
  }
}

// Function to validate individual field
function validateField(field: HTMLInputElement | HTMLTextAreaElement): boolean {
  const value = field.value.trim();
  let isValid = true;
  let errorMessage = '';

  if (field.hasAttribute('required') && !value) {
    isValid = false;
    errorMessage = 'This field is required';
  }

  if (!isValid) {
    showFieldError(field, errorMessage);
  } else {
    clearFieldError(field);
  }

  return isValid;
}

// Function to validate checkbox
function validateCheckbox(checkbox: HTMLInputElement): boolean {
  const isValid = checkbox.checked;

  if (!isValid) {
    showCheckboxError(checkbox, 'You must accept the privacy policy');
  } else {
    clearCheckboxError(checkbox);
  }

  return isValid;
}

// Function to validate entire form
function validateForm(form: HTMLFormElement): boolean {
  const inputs = form.querySelectorAll('input[required], textarea[required]');
  const checkbox = form.querySelector('input[type="checkbox"]') as HTMLInputElement;
  let isFormValid = true;

  // Validate all required fields
  inputs.forEach(input => {
    if (!validateField(input as HTMLInputElement | HTMLTextAreaElement)) {
      isFormValid = false;
    }
  });

  // Validate checkbox
  if (checkbox && !validateCheckbox(checkbox)) {
    isFormValid = false;
  }

  return isFormValid;
}

// Function to show field error
function showFieldError(field: HTMLInputElement | HTMLTextAreaElement, message: string): void {
  clearFieldError(field);

  field.classList.add('border-red-500');
  field.classList.remove('border-white');

  // Find the label for this field
  const fieldContainer = field.parentNode;
  const label = fieldContainer?.querySelector('label') as HTMLLabelElement;

  if (label) {
    const errorSpan = document.createElement('span');
    errorSpan.className = 'field-error text-red-500 text-sm ml-2';
    errorSpan.textContent = ` ${message}`;

    label.appendChild(errorSpan);
  }
}

// Function to clear field error
function clearFieldError(field: HTMLInputElement | HTMLTextAreaElement): void {
  field.classList.remove('border-red-500');
  field.classList.add('border-white');

  // Find and remove error from label
  const fieldContainer = field.parentNode;
  const label = fieldContainer?.querySelector('label') as HTMLLabelElement;

  if (label) {
    const errorSpan = label.querySelector('.field-error');
    if (errorSpan) {
      errorSpan.remove();
    }
  }
}

// Function to show checkbox error
function showCheckboxError(checkbox: HTMLInputElement, message: string): void {
  clearCheckboxError(checkbox);

  const label = checkbox.closest('label');
  if (label) {
    //label.classList.add('text-red-500');

    const errorDiv = document.createElement('div');
    errorDiv.className = 'checkbox-error text-red-500 text-sm mt-1';
    errorDiv.textContent = message;

    label.parentNode?.insertBefore(errorDiv, label.nextSibling);
  }
}

// Function to clear checkbox error
function clearCheckboxError(checkbox: HTMLInputElement): void {
  const label = checkbox.closest('label');
  if (label) {
    label.classList.remove('text-red-500');

    const errorDiv = label.parentNode?.querySelector('.checkbox-error');
    if (errorDiv) {
      errorDiv.remove();
    }
  }
}

// Function to clear all validation errors
function clearValidationErrors(form: HTMLFormElement): void {
  const fieldErrors = form.querySelectorAll('.field-error, .checkbox-error');
  fieldErrors.forEach(error => error.remove());

  const inputs = form.querySelectorAll('input, textarea');
  inputs.forEach(input => {
    input.classList.remove('border-red-500', 'text-red-500');
  });

  const labels = form.querySelectorAll('label');
  labels.forEach(label => {
    label.classList.remove('text-red-500');
  });
}

// Function to show success/error messages
function showMessage(message: string, type: 'success' | 'error'): void {
  // Remove existing message if any
  const existingMessage = document.querySelector('.form-message');
  if (existingMessage) {
    existingMessage.remove();
  }

  // Create new message element
  const messageDiv = document.createElement('div');
  messageDiv.className = `form-message p-2 rounded text-xs lg:text-sm ${
    type === 'success'
      ? 'bg-green-500/20 text-green-300 border border-green-500/30'
      : 'bg-red-500/20 text-red-300 border border-red-500/30'
  }`;
  messageDiv.textContent = message;

  // Insert message before the submit button
  const submitButton = document.querySelector('button[type="submit"]');
  if (submitButton && submitButton.parentNode) {
    submitButton.parentNode.insertBefore(messageDiv, submitButton.nextElementSibling);

    // Auto-remove message after 5 seconds
    setTimeout(() => {
      messageDiv.remove();
    }, 5000);
  }
}

// Accordion functionality for FAQ section
function setupAccordion(): void {
  const accordionItems = document.querySelectorAll('[data-accordion-item]');

  accordionItems.forEach(item => {
    const header = item.querySelector('[data-accordion-header]') as HTMLElement;
    const content = item.querySelector('[data-accordion-content]') as HTMLElement;
    const closeIcon = item.querySelector('[data-accordion-close]') as HTMLImageElement;
    const openIcon = item.querySelector('[data-accordion-open]') as HTMLImageElement;

    if (!header || !content || !closeIcon || !openIcon) return;

    header.addEventListener('click', () => {
      const isOpen = !content.classList.contains('hidden');

      if (isOpen) {
        // Close accordion
        content.classList.add('hidden');
        closeIcon.classList.remove('hidden');
        openIcon.classList.add('hidden');
      } else {
        // Open accordion
        content.classList.remove('hidden');
        closeIcon.classList.add('hidden');
        openIcon.classList.remove('hidden');
      }
    });
  });
}

function setupFeaturesElements(): void {
  const featuresButtons = document.querySelectorAll('[data-feature-button]');
  featuresButtons.forEach(button => {
    button.addEventListener('click', () => {
      const featureId = button.getAttribute('data-feature-button');
      if (!featureId) {
        return;
      }

      const featureContent = document.querySelectorAll(`[data-feature="${featureId}"]`);
      if (!featureContent) {
        return;
      }

      featuresButtons.forEach(btn => {
        btn.classList.remove('text-primary-300');

        const icon = btn.querySelector('svg');
        if (!icon) {
          return;
        }

        icon.classList.remove('stroke-primary-300');
        const path = icon.querySelectorAll('path');
        path.forEach(p => {
          p.classList.remove('stroke-primary-300', 'fill-primary-300');
        });
      });

      button.classList.add('text-primary-300');
      const icon = button.querySelector('svg');
      if (icon) {
        icon.classList.add('stroke-primary-300');
        const path = icon.querySelectorAll('path');
        path.forEach((p, k) => {
          p.classList.add('stroke-primary-300');

          if (k === 0) {
            return;
          }
          p.classList.add('fill-primary-300');
        });
      }

      // Hide all feature contents
      const allFeatureContents = document.querySelectorAll('[data-feature]');
      allFeatureContents.forEach(content => {
        content.setAttribute('data-feature-click', 'false');
      });

      featureContent.forEach(content => {
        content.setAttribute('data-feature-click', 'true');
      });
    });
  });
}


// Add type definition for window.opera
declare global {
  interface Window { 
    opera?: any;
  }
}

function isMobileDevice() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

// Initialize accordion when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  loadCards();
  setupFormSubmission();
  setupAccordion();
  setupFeaturesElements();
  AOS.init({ duration: 600 });

  const isMobile = isMobileDevice();
  const parallaxElements = document.querySelector('.rellax');
  if (isMobile) {
   parallaxElements?.setAttribute('data-rellax-max', '85');
  } else {
    parallaxElements?.setAttribute('data-rellax-max', '60');
  }

  new Rellax('.rellax');
  new Swiper('.swiper', {
    modules: [Autoplay],
    slidesPerView: 'auto',
    centerInsufficientSlides: true,
    freeMode: true,
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    spaceBetween: 32,
    speed: 10000,
  });
});
